import { render, staticRenderFns } from "./PersonListSection.vue?vue&type=template&id=7867377a&"
import script from "./PersonListSection.vue?vue&type=script&lang=js&"
export * from "./PersonListSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports